module.exports = __webpack_public_path__ + "img/login-background1.94f6b491.jpg";